<template>
    <button
        type="button"
        class="app-button relative font-semibold py-4 rounded-lg w-full transition-colors duration-300"
        :class="buttonClass"
        :disabled="disabled || loading"
        @click="$emit('click', $event)"
    >
        <slot />
        <div
            v-if="loading"
            class="absolute rounded-lg inset-0 flex justify-center items-center bg-gray-300"
            aria-hidden="true"
        >
            <svg class="animate-spin h-5 w-5 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
        </div>
    </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type Variant = 'primary' | 'secondary' | 'warning' | 'white';

const props = defineProps<{
    disabled?: boolean;
    loading?: boolean;
    variant?: Variant;
}>();

defineEmits<{ click: [event: MouseEvent] }>();

const buttonClass = computed(() => {
    if (props.disabled || props.loading) return 'cursor-default bg-gray-300 text-gray-500';
    const variant = props.variant ?? 'primary';
    return {
        primary: 'bg-primary-800 hover:bg-opacity-70 text-white cursor-pointer',
        secondary: 'bg-primary-500 bg-opacity-80 hover:bg-opacity-50 text-primary-800 cursor-pointer',
        warning: 'bg-red-400 bg-opacity-25 hover:bg-opacity-35 text-red-400 cursor-pointer',
        white: 'bg-white hover:bg-gray-100 text-gray-600 cursor-pointer',
    }[variant];
});
</script>
